import _ from 'lodash'
export function  calcDiscount(disc,bsum){
  if(disc){
    if(disc.val_type=="percentage"){
      return parseFloat(bsum)*(disc.val/100)
    }else{
      return disc.val;
    }
  }else{
    return 0
  }
}


export function  getBillSum(clsid,bsums){
  //let cbill = bsums.filter(x=>x.cid==clsid);

  let cbill = _.find(bsums, ['cid', clsid])
  //console.log('cbill',cbill)
   return cbill?cbill.cbsum:0

}


export const validRules = {
  required:[v => !!v || "this field is required"],
  password: [
    v => !!v || "Password is required",
    v =>(v && v.length >= 8) || "Password must not be less than 8 characters"
],
  email: [
    // v => !!v || "E-mail is required",
    v =>(!v ||
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
      "E-mail must be valid"
  ],
  email2: [

    v =>(!v ||
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
      "E-mail must be valid"
  ],

}







// WEBPACK FOOTER //
// ./resources/assets/js/common/index.js